var exports = {
  "x": "xa15a2ab7--7e2150--button",
};

module.exports = exports;
